import React from "react";
import { Button, Modal, Tooltip, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { QuestionList } from "../FU-63/QuestionList";
import { useAuth } from "../Auth/Auth";
import { http } from "../Common/http";
import { isNullOrSpace } from "../Common/Utils";

interface Props {
  allowClear?: boolean;
  width?: number;
  value?: string;
  onChange?: (value: string) => void;
}
interface QuestionData {
  questionId: string;
  title: string;
  contents: string;
  updatedOn: Date;
}

export const QuestionSelecter = ({ value, width = 200, onChange }: Props) => {
  const { accessToken } = useAuth();
  const [visible, setVisible] = React.useState(false);
  const [questionNameLabel, setQuestionNameLabel] = React.useState("");
  const [defalutValue, setDefalutValue] = React.useState("");
  // const [qpage, setQpage] = React.useState<QuestionList>();
  React.useEffect(() => {
    if (value !== undefined && value != null && value.length > 0) {
      setDefalutValue(value);
      const initData = async () => {
        try {
          const result = await http<QuestionData>({
            path: "/Question/" + value,
            method: "get",
            accessToken: accessToken,
          });
          if (result.ok) {
            setQuestionNameLabel(result.body!.title);
            onChange?.(result.body!.questionId);
            // if (this.props.onDataSelect) this.props.onDataSelect(result.body);
          }
        } catch (error) {
          console.log(error);
        }
      };
      initData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onDataChange = (newValue: any) => {
    setQuestionNameLabel(newValue.title);
    onChange?.(newValue.questionId);
    setVisible(false);
  };

  const onSearchClick = (event) => {
    setVisible(true);
  };

  return (
    <>
      <Tooltip title={questionNameLabel}>
        <Space size={1}>
          {/* <Input
            disabled={true}
            value={questionNameLabel}
            style={{ width: width, cursor: "pointer" }}
            allowClear={true}
            onClick={onSearchClick}
          /> */}
          <Button
            type="default"
            style={{
              width: width,
            }}
            onClick={onSearchClick}
          >
            <span className="buttontext">
              {isNullOrSpace(questionNameLabel) ? "　" : questionNameLabel}
            </span>
          </Button>
          <Button onClick={onSearchClick}>
            <span className="buttontext">
              <SearchOutlined />
            </span>
          </Button>
        </Space>
      </Tooltip>
      <Modal
        title="問題選択"
        maskClosable={false}
        centered
        visible={visible}
        // onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        width={1200}
        footer={null}
      >
        <QuestionList
          isPopup={true}
          onDataSelect={onDataChange}
          defaultId={defalutValue}
        />
        {/* {qpage} */}
      </Modal>
    </>
  );
};
